import Listings from '../src/Listings/index.tsx';
export default Listings;
